import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { RestProvider } from "../providers/rest";
import { HttpClient, HttpClientModule } from "@angular/common/http";

import { CommonModule } from "@angular/common";
// import { AppRoutingModule } from './app-routing.module';

import { ScreenService } from "./services/screen.service";

import { MatCheckboxModule, MatSlideToggleModule } from "@angular/material";
import { GtagModule } from "angular-gtag";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";

import { AppComponent } from "./app.component";
import { LandingObservatoireComponent } from "./landing-observatoire/landing-observatoire.component";
import { Preview2020Component } from "./preview2020/preview2020.component";
import { NotFoundComponent } from "./not-found/not-found.component";

const appRoutes: Routes = [
  { path: "", component: LandingObservatoireComponent },
  { path: "preview/edition-2020", component: Preview2020Component },
  // { path: 'blog', component: Preview2020Component },
  { path: "**", component: NotFoundComponent },
];
@NgModule({
  declarations: [
    AppComponent,
    LandingObservatoireComponent,
    Preview2020Component,
    NotFoundComponent,
  ],
  imports: [
    // FormBuilder,
    GtagModule.forRoot({ trackingId: "UA-159307493-1", trackPageviews: false }),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    RouterModule.forRoot(appRoutes),
    HttpClientModule,
    CommonModule,
  ],
  providers: [RestProvider, HttpClientModule, HttpClient, ScreenService],
  bootstrap: [AppComponent],
})
export class AppModule {}
